import { useEffect, useState } from 'react';
import { getUsageTracker, init as setNewTracker } from 'EmailComponents/utils/tracking';
import { withSessionReplay } from 'usage-tracker-session-replay';
export const useTrackerWithSR = activateSessionReplay => {
  const [isActivated, setIsActivated] = useState(false);
  const tracker = getUsageTracker();
  useEffect(() => {
    if (!tracker || !activateSessionReplay || isActivated) {
      return;
    }
    const trackerWithSR = withSessionReplay(tracker, {
      // 0 - 1, 0 means no sampling, 1 means all events are sent
      // This value represents 1%
      sampleRate: 0.01
    });

    // replace the tracker returned by `getUsageTracker()`
    setNewTracker(trackerWithSR);
    setIsActivated(true);
  }, [activateSessionReplay, isActivated, setIsActivated, tracker]);
};